'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _vouches = require('./vouches.component');

var _vouches2 = _interopRequireDefault(_vouches);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vouchesModule = _angular2.default.module('app.containers.vouches', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('vouches', {
    url: '/vouches',
    template: '<vouches></vouches>'
  });
}).component('vouches', _vouches2.default);

exports.default = vouchesModule;


/** WEBPACK FOOTER **
 ** ./client/app/containers/vouches/vouches.js
 **/